// Mirrors the UserPreferenceKey enum in the GraphQL schema.
export const USER_PREFERENCE_KEYS = {
  reportHeaderCollapsed: "reportHeaderCollapsed"
};
